import React, { Component } from 'react';
import { FormGroup, Label, Input, FormText } from 'reactstrap';

export default class Careers extends Component {
    constructor(props){
        super(props)
        this.state={
            mobile:false
        }
    }
    componentDidMount(){
        window.scrollTo(0,0)
        if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            this.setState({mobile:true})
        }
    }
    render() {
        const {mobile} = this.state
        return (
            <React.Fragment>
                <div className="container contact-margin">
                    <div className="contactus-bg">
                        <div className={!mobile ? "join-section text-left" : "join-section"}>
                            <h3 className={ "header-join "}>Join DETASAD Family</h3>
                            <p className="join-paragraph">At DETASAD we value those who strive to tackle complex challenges and
                            take the initiative to think ‘outside of the box.’
                            We are looking for people who can work in a fast pace setting,
                            rapidly adapt to new situations and set new performance standards within the company and industry.
                            DETASAD embraces candidates who want to take their careers to the next level and further their skills.</p>
                        </div>
                        <hr/>
                        <div className={!mobile?"career-section text-left":"career-section"}>
                            <div className="row">
                                <div className="col-md-6">
                                    <h3 className="head-one">WHY WORK WITH DETASAD?</h3>
                                    <p className="paragraph-one">We consider our human capital one of our biggest assets. We value each and every one of our employees.
                                     Employees are given the opportunity to grow within the company. We believe in sponsoring employee development programs, and investing in our staff, 
                                     which will help to improve your leadership skills and ultimately unlock your full potential.</p>
                                </div>
                                <div className="col-md-6">
                                    <h3 className="head-one">THE NEXT BIG STEP IN YOUR CAREER</h3>
                                    <p className="paragraph-one">Congratulations on taking the first step in joining our team of diverse and multi-talented professionals 
                                    and being part of the DETASAD family. By being part of DETASAD you’re taking the next big step in your career.</p>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className={!mobile ? "cv-upload-form text-left":"cv-upload-form"}>
                            <p className={!mobile ? "header-join text-left":"header-join"}>Upload Your CV</p>
                            <div className="row">
                                <div className="col-md-4">
                                    <FormGroup>
                                        <Label for="exampleEmail" className="form-label-contact">Your Name</Label>
                                        <Input type="text" name="fname"  placeholder="Please Enter Your First Name" />
                                    </FormGroup>
                                </div>
                                <div className="col-md-4">
                                    <FormGroup>
                                        <Label for="exampleEmail" className="form-label-contact">Section</Label>
                                        <Input type="select" name="fname" >
                                            <option value="HR">HR</option>
                                            <option value="Marketing">Marketing</option>
                                            <option value="IT">IT</option>
                                            <option value="Finance">Finance</option>
                                            <option value="Engineering">Engineering</option>
                                            <option value="Legal">Legal</option>
                                            <option value="Strategy">Strategy</option>
                                            <option value="Administration">Administration</option>
                                            <option value="Sales">Sales</option>
                                        </Input>
                                    </FormGroup>
                                </div>
                                <div className="col-md-4">
                                <FormGroup>
                                    <Label for="exampleFile">File</Label>
                                    <Input type="file" name="file" id="exampleFile" />
                                    <FormText color="muted">
                                       Please attach your CV here
                                   </FormText>
                                </FormGroup>
                                </div>
                            </div>
                            <button className="btn btn-primary" onClick={(e)=>e.preventDefault()}>Share</button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}